export default {
    useInfo:state => state.user.useInfo
}